/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    TravelDateRange,
    TravelDateRangeFromJSON,
    TravelDateRangeFromJSONTyped,
    TravelDateRangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRRuleUpdateRequest
 */
export interface SSRRuleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SSRRuleUpdateRequest
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRRuleUpdateRequest
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SSRRuleUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRRuleUpdateRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRRuleUpdateRequest
     */
    ctce?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRRuleUpdateRequest
     */
    ctcm?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SSRRuleUpdateRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SSRRuleUpdateRequest
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SSRRuleUpdateRequest
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof SSRRuleUpdateRequest
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof SSRRuleUpdateRequest
     */
    bookingDateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof SSRRuleUpdateRequest
     */
    bookingDateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<TravelDateRange>}
     * @memberof SSRRuleUpdateRequest
     */
    travelDates?: Array<TravelDateRange> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRRuleUpdateRequest
     */
    excludeCarriers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRRuleUpdateRequest
     */
    disabled?: boolean;
}

export function SSRRuleUpdateRequestFromJSON(json: any): SSRRuleUpdateRequest {
    return SSRRuleUpdateRequestFromJSONTyped(json, false);
}

export function SSRRuleUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRRuleUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'ctce': !exists(json, 'ctce') ? undefined : json['ctce'],
        'ctcm': !exists(json, 'ctcm') ? undefined : json['ctcm'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'bookingDateTimeRestrictions': !exists(json, 'bookingDateTimeRestrictions') ? undefined : (json['bookingDateTimeRestrictions'] === null ? null : (json['bookingDateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'bookingDateTimeRestrictionsTimeZone': !exists(json, 'bookingDateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['bookingDateTimeRestrictionsTimeZone']),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(TravelDateRangeFromJSON)),
        'excludeCarriers': !exists(json, 'excludeCarriers') ? undefined : json['excludeCarriers'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function SSRRuleUpdateRequestToJSON(value?: SSRRuleUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
        'description': value.description,
        'comment': value.comment,
        'ctce': value.ctce,
        'ctcm': value.ctcm,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'bookingDateTimeRestrictions': value.bookingDateTimeRestrictions === undefined ? undefined : (value.bookingDateTimeRestrictions === null ? null : (value.bookingDateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'bookingDateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.bookingDateTimeRestrictionsTimeZone),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(TravelDateRangeToJSON)),
        'excludeCarriers': value.excludeCarriers,
        'disabled': value.disabled,
    };
}


